/**
 * コンサルタントが提案編集可能か判定する
 * @param args
 */
export const getIsOfferDisabled = (args) => {
    const { hasOffer, ignoreCallEndDate, isCalling } = args;
    // 募集期限切れ（募集期限を無視できる場合は例外）、もしくは提案済みの時は提案意向の更新を許可しない
    return (!isCalling && !ignoreCallEndDate) || hasOffer;
};
